import { render, staticRenderFns } from "./DownloadBannerEx.vue?vue&type=template&id=02038d39&scoped=true"
import script from "./DownloadBannerEx.vue?vue&type=script&lang=js"
export * from "./DownloadBannerEx.vue?vue&type=script&lang=js"
import style0 from "./DownloadBannerEx.vue?vue&type=style&index=0&id=02038d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02038d39",
  null
  
)

export default component.exports